import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { EditWinmediaComponent } from './winmedia/editWinmedia.component';
import { EditWinmediaDialogComponent } from './winmedia/editWinmediaDialog.component';
import { EditPreselectMonthlyPlaylistComponent } from './preselectMonthlyPlaylist/editPreselectMonthlyPlaylist.component';
import { EditPreselectCategoryComponent } from './preselectCategory/editPreselectCategory.component';
import { FinalizeDialogComponent } from './finalizeDialog.component';
import { UnlockConfirmDialogComponent } from './unlockConfirmDialog.component';
import { SendFinalizedPlaylistConfirmDialogComponent } from './sendFinalizedPlaylistConfirmDialog.component';

import { EditService } from '../../providers/edit/edit.service';

import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GetNextMondayPipe } from './preselectMonthlyPlaylist/get-next-monday.pipe';


@NgModule({
  declarations: [
    EditWinmediaComponent,
    EditWinmediaDialogComponent,
    EditPreselectMonthlyPlaylistComponent,
    EditPreselectCategoryComponent,
    FinalizeDialogComponent,
    UnlockConfirmDialogComponent,
    SendFinalizedPlaylistConfirmDialogComponent,
    GetNextMondayPipe
  ],
  imports: [
    CommonModule,
    DragDropModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    MatPaginatorModule,
    MatChipsModule,
    MatAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule
  ],
  providers: [
    EditService
  ]
})
export class EditModule { }
